export enum Layout {
  Desktop = 'desktop',
  Mobile = 'mobile',
}
